import { useGetFertilizers } from '@practium/features/api';
import { usePostAdviceCorrectionCreate } from '../../api/hooks/recommendations';
import { buildCorrectionAdvicePayload } from '../services/correctionAdvicePayload';
import { useCorrectionStore } from '../store/correctionStore';
import type { PlantingAdvice } from '../types';
import type { SavedCorrectionCalculation } from '../services/correctionSaveFeedback';

export const useSaveCorrectionAdvice = () => {
	const { data: fertilizers = [] } = useGetFertilizers();
	const { mutateAsync, isPending } = usePostAdviceCorrectionCreate();

	const save = async (): Promise<{
		advice: PlantingAdvice;
		calculations: SavedCorrectionCalculation[];
	}> => {
		const state = useCorrectionStore.getState();
		const calculations: SavedCorrectionCalculation[] = [
			...(state.dirtyCalculations.includes('calagem') ? (['Calagem'] as const) : []),
			...(state.dirtyCalculations.includes('fosfatagem') ? (['Fosfatagem'] as const) : []),
			...(state.dirtyCalculations.includes('gessagem') ? (['Gessagem'] as const) : []),
		];
		const payload = buildCorrectionAdvicePayload(state, fertilizers);
		const response = await mutateAsync(payload);
		const saved = {
			...state.advice,
			...payload,
			...(response ?? {}),
			_id: response?._id ?? payload._id,
			metadatas: payload.metadatas,
		} as PlantingAdvice;
		useCorrectionStore.getState().setAdvice(saved);
		return { advice: saved, calculations };
	};

	return { save, isPending };
};
